import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { MainContainer } from "./MailTokenDescription.styled";

const MailTokenDescription = (props) => {
  const { data } = props;

  return (
    <MainContainer>
      <div className="mailtoken-list__description" title={data}>
        {data || "-"}
      </div>
    </MainContainer>
  );
};

MailTokenDescription.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MailTokenDescription);
